export const TILE_WIDTH = 100
export const TILE_HEIGHT = 150
export const SPRITESHEET_WIDTH = 900
export const SPRITESHEET_HEIGHT = 750

export const TILE_SCALES = {
  xs: 0.5,
  sm: 0.65,
  md: 1, // can show 9 tiles with nothing else in a row
  lg: 1.5,
  xl: 2, // can fit 4 with a little space
  xxl: 3, // can fit 3 without space, looks lowkey bad
}

export const SUITS = ['BING', 'TIAO', 'WAN']
export const NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9]
export const HONORS = ['JIAN', 'FENG']
export const DRAGONS = ['ZHONG', 'FA', 'BAIPI']
export const WINDS = ['DONG', 'NAN', 'XI', 'BEI']

export const ALL_HONORS = [...WINDS, ...DRAGONS]
export const ALL_CATEGORIES = [...SUITS, ...WINDS, ...DRAGONS]
export const CHI_SAFE_NUMBERS = [1, 2, 3, 4, 5, 6, 7]

export const getTileKey = (face, number) => (number ? `${face}-${number}` : face)
const createAllTilesList = () => {
  return [
    ...SUITS.reduce((collect, suit) => ([...collect, ...NUMBERS.map(i => getTileKey(suit, i))]), []),
    ...WINDS,
    ...DRAGONS
  ]
}
export const ALL_TILES = createAllTilesList()

export const LABELS = {
  'ZHONG': {
    en: 'red',
    zh: ''
  },
  'FA': {
    en: 'green',
    zh: ''
  },
  'BAIPI': {
    en: 'white',
    zh: ''
  },
  'DONG': {
    en: 'east',
    zh: ''
  },
  'NAN': {
    en: 'south',
    zh: ''
  },
  'XI': {
    en: 'west',
    zh: ''
  },
  'BEI': {
    en: 'north',
    zh: ''
  },
}

const createTileMap = () => {

  const tilemap = {}

  SUITS.forEach((suit, idx) => {
    tilemap[suit] = []
    for (let i = 1; i <= 9; i++) {
      tilemap[suit][i] = [(i - 1) * TILE_WIDTH, idx * TILE_HEIGHT]
    }
  })

  tilemap.JIAN = []
  DRAGONS.forEach((dragon, i) => {
    tilemap.JIAN[dragon] = [i * TILE_WIDTH, 3 * TILE_HEIGHT]
  })

  tilemap.FENG = []
  WINDS.forEach((wind, i) => {
    tilemap.FENG[wind] = [(i + 3) * TILE_WIDTH, 3 * TILE_HEIGHT]
  })

  tilemap.HUA = []
  for (let i = 1; i <= 8; i++) {
    tilemap.HUA[i] = [(i - 1) * TILE_WIDTH, 4 * TILE_HEIGHT]
  }

  return tilemap
}

export const TILES = createTileMap()
export const BING = TILES.BING
export const TIAO = TILES.TIAO
export const WAN = TILES.WAN
export const JIAN = TILES.JIAN
export const FENG = TILES.FENG
export const HUA = TILES.HUA

export const ERROR_TILE = [8 * TILE_WIDTH, 4 * TILE_HEIGHT]
